import { render, staticRenderFns } from "./SimpleCard.vue?vue&type=template&id=02a5d413&scoped=true&"
var script = {}
import style0 from "./SimpleCard.vue?vue&type=style&index=0&id=02a5d413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a5d413",
  null
  
)

export default component.exports